import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IExecutionLog } from "@/interfaces/execution-log.interfaces";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class ExecutionLogService {
  private baseUrl = "api/v1/executionlog";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IExecutionLog>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const executionLogs = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return executionLogs;
  }

  async filter(
    filter: IFilter<IExecutionLog>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IExecutionLog>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async getById(logId: number, accessToken?: string): Promise<IExecutionLog> {
    const config = accessToken
      ? { headers: { Authorization: `Bearer ${accessToken}` } }
      : undefined;

    const executionLog = await httpRequest.get(`${this.baseUrl}/${logId}`, config);

    return executionLog;
  }

  async create(formData: IExecutionLog): Promise<IExecutionLog> {
    const executionLog = await httpRequest.post(this.baseUrl, formData);
    return executionLog;
  }

  async update(formData: IExecutionLog, logId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${logId}`, formData);
  }

  async delete(logId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${logId}`);
  }
}

const executionLogService = new ExecutionLogService();
export default executionLogService;
